import { Injectable } from "@angular/core";
import { StoreBase } from "../shared/models/bases/storeBase";
import { User } from "../shared/models";

@Injectable({
  providedIn: 'root'
})

export class UserStore extends StoreBase<User> { }
